import React from 'react';
import LeMuseeEnBref from '../components/LeMuseeEnBref';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <LeMuseeEnBref />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
